(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["launch-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('launch-countdown')) {
    customElements.define('launch-countdown', class extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target || '');
        if (!Number.isFinite(this.target)) return;
        const date = this.querySelector('[data-launch-date]');
        if (date) {
          const parts = new Intl.DateTimeFormat(document.documentElement.lang || 'fo-FO', {
            timeZone: 'Atlantic/Faroe', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          }).formatToParts(new Date(this.target)).reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
          }, {});
          date.textContent = `${parts.day} ${parts.month} ${parts.year} — Kl. ${parts.hour}:${parts.minute}`;
        }
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() { clearInterval(this.interval); }

      update() {
        let remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          const display = this.querySelector(`[data-unit="${unit}"]`);
          if (display) display.textContent = String(value).padStart(2, '0');
        }
        if (remaining === 0) clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
